import { render, staticRenderFns } from "./WSReadCard.vue?vue&type=template&id=d7f2271e&"
import script from "./WSReadCard.vue?vue&type=script&lang=js&"
export * from "./WSReadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports